import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/service/api/api.service';
import { SelectedColumn } from 'app/models/columns-dropdowns';
import { Observable } from 'rxjs';
import {
  ApiResponseReader,
  ApiResponseService,
} from '../api/api-response.service';

@Injectable({
  providedIn: 'root',
})
export class TbeService {
  // This api version is needed for agent 1
  private readonly apiVersion: string = `v1/tbe/`;

  constructor(
    private apiService: ApiService,
    private apiResponseService: ApiResponseService
  ) {}

  postDocumentToTbeCleansing(file: File): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}` + `upload`;
    const formData = new FormData();
    formData.append('file', file);

    return this.apiResponseService.prepareResponseForReading(
      this.apiService.post(slug, formData, '')
    );
  }

  getLatestTBE(projectId: string): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}` + `${projectId}`;
    return this.apiResponseService.prepareResponseForReading(
      this.apiService.get(slug, {}, '')
    );
  }

  getLatestTBEWithoutID(): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}` + `projects`;
    return this.apiResponseService.prepareResponseForReading(
      this.apiService.get(slug, {}, '')
    );
  }

  getInitialUploadedTBE(
    projectId: string,
    columnSetId?: string,
    selectedColumns?: SelectedColumn[]
  ): Observable<ApiResponseReader> {
    if (!columnSetId) {
      const slug: string = `${this.apiVersion}` + `${projectId}`;
      return this.apiResponseService.prepareResponseForReading(
        this.apiService.get(slug, { vdf: true }, '')
      );
    } else {
      const slug: string =
        `${this.apiVersion}` + `${projectId}/columns/preview`;
      return this.apiResponseService.prepareResponseForReading(
        this.apiService.post(
          slug,
          { id: columnSetId, selected_columns: selectedColumns },
          ''
        )
      );
    }
  }

  postSendColumnsAndStartCleansing(
    projectId: any,
    columns: any
  ): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}` + `${projectId}/columns`;
    return this.apiResponseService.prepareResponseForReading(
      this.apiService.post(slug, columns, '')
    );
  }

  deleteTrialBalance(projectId: string): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}`;
    return this.apiResponseService.prepareResponseForReading(
      this.apiService.delete(slug, projectId, '')
    );
  }

  completeTrialBalance(
    projectId: string,
    correctedTBFile: File | null = null
  ): Observable<ApiResponseReader> {
    const slug: string = `${this.apiVersion}` + `${projectId}/complete`;

    if (correctedTBFile) {
      const formData = new FormData();
      formData.append('file', correctedTBFile);
      return this.apiResponseService.prepareResponseForReading(
        this.apiService.put(slug, '', formData, '')
      );
    }

    return this.apiResponseService.prepareResponseForReading(
      this.apiService.put(slug, '', {}, '')
    );
  }

  undoCompleteTrialBalance(projectId: string): Observable<void> {
    const slug: string = `${this.apiVersion}` + `${projectId}/complete-undo`;

    return this.apiService.post(slug, {}, '', '');
  }
}
